import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { ReactiveComponent } from "../../entities/base-component";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { unwrapRef } from "@/utils/reactive";

export class DoorCalculationStrategy extends CalculationStrategy {
    calculate = (component: ReactiveComponent): PriceResult => {
        return {
            price: this.calculatePriceForType(component, CostDealType),
            priceB2C: this.calculatePriceForType(component, B2CDealType),
            priceB2B: this.calculatePriceForType(component, B2BDealType),
        };
    };

    private calculatePriceForType(
        component: ReactiveComponent,
        dealType: string,
    ) {
        const qty = unwrapRef(component.qty);
        const price = component.price.getSystemPrice(dealType).getValue();

        return price * qty;
    }
}
